import { render, staticRenderFns } from "./webgl.vue?vue&type=template&id=35b07b3a&scoped=true&"
import script from "./webgl.vue?vue&type=script&lang=js&"
export * from "./webgl.vue?vue&type=script&lang=js&"
import style0 from "./webgl.vue?vue&type=style&index=0&id=35b07b3a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35b07b3a",
  null
  
)

export default component.exports